"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    root: {
        transition: "opacity 0.3s ease-in-out, transform 0.5s ease-in-out",
        position: "absolute",
        bottom: "50px",
        borderRadius: ".375rem",
        overflow: "auto",
        border: "1px solid #e5e7eb",
        "&.active": {
            opacity: 1,
        },
        "&.inactive": {
            transform: "translateY(50px)",
            opacity: 0,
            visibility: "hidden",
        },
    },
};
exports.default = styles;
//# sourceMappingURL=styles.js.map